/** Three r183 disposes ShadowNode when a compiled light stops casting shadows.
 * Cached materials can still update that node and dereference its released map.
 * Keep casting latched after the first high tier; lower tiers hide the shadow
 * via its uniform and stop map rendering without releasing GPU resources. */
export function applyShadowQuality(light, enabled) {
  if (!light) return;
  if (enabled) light.castShadow = true;
  light.shadow.intensity = enabled ? 1 : 0;
  light.shadow.autoUpdate = enabled;
  light.shadow.needsUpdate = enabled;
}
